import React from 'react';
import Webcam from 'react-webcam';

import Alert from '@material-ui/lab/Alert';
import { WebcamWidths } from 'constants/camera';

import WebcamError from 'components/WebcamError';

import styles from './styles.module.scss';

const WebcamDisplay = ({
  isMobile,
  selectedCameraId,
  onUserMediaError,
  webcamRef,
  containerRef,
  cameraError,
  previewImage
}) => {
  const videoConstraints = {
    width: { ideal: 1080 },
    height: { ideal: 1920 },
    deviceId: selectedCameraId ? { exact: selectedCameraId } : undefined,
    facingMode: !selectedCameraId ? 'environment' : undefined
  };

  if (cameraError) {
    return cameraError.name === 'NotReadableError' ||
      cameraError.name === 'TrackStartError' ? (
      <div className={styles.errorContainer}>
        <WebcamError />
      </div>
    ) : (
      <Alert severity="warning">
        Cannot start camera: {cameraError.toString()}
      </Alert>
    );
  }

  if (previewImage) return null;

  return (
    <div
      className={`${styles.cameraLayout} camera-layout-fixed`}
      ref={containerRef}
    >
      <Webcam
        key={`${selectedCameraId}-${WebcamWidths.WEBCAM_MOBILE}`}
        className={styles.webcam}
        audio={false}
        ref={webcamRef}
        forceScreenshotSourceSize={true}
        screenshotFormat="image/jpeg"
        mirrored={!isMobile}
        screenshotQuality={1}
        videoConstraints={videoConstraints}
        onUserMediaError={onUserMediaError}
      />
    </div>
  );
};

export default WebcamDisplay;
